import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import AddAmenityForm from "./AddAmenityForm";
import { Grid } from "@mui/material";
// import { useNavigate } from "react-router-dom";

function AddAmenity() {
  // const navigate = useNavigate();
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Add Amenity</h1>
          </Grid>
        </Grid>
        <div className="addEditAmenityOut">
          <AddAmenityForm />
        </div>
      </div>
    </>
  );
}

export default AddAmenity;
